/**
 * zjh 20180923
 */

const load =  {}
/**
 * 动态添加css 样式函数
 * @param {*} str css样式文件
 */
load.css = function(str) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.innerHTML = str;
    head.appendChild(style);
}

/**
 * 动态添加js文件到header里面
 * @param {*} src js文件路径
 * @param {*} callback js加载完成的回调函数
 * @param {*} charset 【选填】被加载的js文件的编码格式
 */
load.js = function(src, callback, charset) {
    var el = document.createElement('script');
    if (callback) {
        el.onload = el.onerror = el.onreadystatechange = function () {
            var s = this.readyState;
            if (!s || (s && (s == 'loaded' || s == 'complete'))) {
                callback(src);
            }
        }
    }
    el.type = 'text/javascript';
    el.src = src;
    el.async = 'true';
    if (charset) {
        el.charset = charset;
    }
    document.getElementsByTagName('head')[0].appendChild(el);
}

/**
 * 图片预加载函数，【注意：预先加载，不是懒加载】
 * @param {*} imgArr 要加载的图片url地址
 * @param {*} underwayCallback 加载进度的回调函数，返回进度数值
 * @param {*} doneCallback 全部加载完成的回调函数
 */
load.img = function(imgArr,underwayCallback,doneCallback){
    var arr = imgArr;
    var num=0;
    for(var i=0;i<arr.length;i++){
        var oImg=new Image(); //新建一个图片对象
        oImg.onload=function(){
            num++;   //图片预加载完成，执行onload里面的代码
            let schedule = num/arr.length*100;
            underwayCallback && underwayCallback(schedule);
            if(schedule == 100){
                doneCallback && doneCallback(schedule);
            }
        }
        oImg.onerror = function(){
            num++;   //图片预加载完成，执行onload里面的代码
            let schedule = num/arr.length*100;
            underwayCallback && underwayCallback(schedule);
            if(schedule == 100){
                doneCallback && doneCallback(schedule);
            }
        }
        oImg.src=arr[i];   //给图片对象添加路径  注意这条代码必须加在onload的后面
    }

}
export default load
